// extracted by mini-css-extract-plugin
export default {"selectList":"LanguageSwitch_selectList__VVtx+","selectText":"LanguageSwitch_selectText__qBayW","globalIcon":"LanguageSwitch_globalIcon__-61Xp","lang":"LanguageSwitch_lang__+aOZa"};